import moment from 'moment-timezone';
import {TIMEZONE_MAP as timezoneMap} from '../../patterns';

const getStoredTimezone = () => {
    const storedStation = JSON.parse(localStorage.getItem("station") || "{}");
    return timezoneMap[storedStation?.timezone] || "UTC";
};

const getCurrentQuarterDates = () => {
    const now = moment().tz(getStoredTimezone());

    // Determine the current quarter
    const quarter = now.quarter();
    // Calculate the start and end dates of the quarter
    let startOfQuarter, endOfQuarter;
    if (quarter === 1) {
        startOfQuarter = now.clone().month(0).startOf('month'); // January
        endOfQuarter = now.clone().month(2).endOf('month');   // March
    } else if (quarter === 2) {
        startOfQuarter = now.clone().month(3).startOf('month'); // April
        endOfQuarter = now.clone().month(5).endOf('month');   // June
    } else if (quarter === 3) {
        startOfQuarter = now.clone().month(6).startOf('month'); // July
        endOfQuarter = now.clone().month(8).endOf('month');   // September
    } else {
        startOfQuarter = now.clone().month(9).startOf('month'); // October
        endOfQuarter = now.clone().month(11).endOf('month');  // December
    }

    // Format the dates
    const startFormatted = startOfQuarter.format('YYYY-MM-DD');
    const endFormatted = endOfQuarter.format('YYYY-MM-DD');

    return {
        startFormatted, endFormatted
    }

}

const getCurrentYear = () => {
    const now = moment().tz(getStoredTimezone());
    const startOfYear = now.clone().startOf('year').format('YYYY-MM-DD');
    const endOfYear = now.clone().endOf('year').format('YYYY-MM-DD');
    return {
        startOfYear, endOfYear
    }
}

export const getLastNDays = (n) => {
    const now = moment().tz(getStoredTimezone());
    const nDaysAgo = now.clone().subtract(parseInt(n), 'days');
    const nowFormatted = now.format('YYYY-MM-DD');
    const nDaysAgoFormatted = nDaysAgo.format('YYYY-MM-DD');
    return {
        nDaysAgoFormatted,
        nowFormatted
    }
}

export const getLastNDaysFromToday = (n) => {
    const now = moment().tz(getStoredTimezone());
    const startDate = now.clone().subtract(n - 1, 'days').startOf('day');
    const endDate = now.clone().endOf('day');

    return {
        nDaysAgoFormatted: startDate.format('YYYY-MM-DD'),
        nowFormatted: endDate.format('YYYY-MM-DD')
    };
};

const getLastMonth = () => {
    const now = moment().tz(getStoredTimezone());
    const startOfLastMonth = now.clone().subtract(1, 'months').startOf('month');
    const endOfLastMonth = now.clone().subtract(1, 'months').endOf('month');
    const startFormattedMonth = startOfLastMonth.format('YYYY-MM-DD');
    const endFormattedMonth = endOfLastMonth.format('YYYY-MM-DD');
    return {
        startFormattedMonth, endFormattedMonth,
    }
}

const getPreviousQuarter = () => {
    const now = moment().tz(getStoredTimezone());
    const startOfCurrentQuarter = now.clone().startOf('quarter');
    const endOfPreviousQuarter = startOfCurrentQuarter.clone().subtract(1, 'days');
    const startOfPreviousQuarter = endOfPreviousQuarter.clone().startOf('quarter');
    const startFormattedDate = startOfPreviousQuarter.format('YYYY-MM-DD');
    const endFormattedDate = endOfPreviousQuarter.format('YYYY-MM-DD');
    return {
        startFormattedDate, endFormattedDate
    }
}

const getPreviousYear = () => {
    const now = moment().tz(getStoredTimezone());
    const startOfLastYear = now.clone().subtract(1, 'years').startOf('year');
    const endOfLastYear = now.clone().subtract(1, 'years').endOf('year');
    const startFormattedDate = startOfLastYear.format('YYYY-MM-DD');
    const endFormattedDate = endOfLastYear.format('YYYY-MM-DD');
    return {
        startFormattedDate, endFormattedDate
    }
}

const getNextNDays = (n) => {
    const now = moment().tz(getStoredTimezone());
    const nDaysFromNow = now.clone().add(parseInt(n), 'days');
    const nowFormatted = now.format('YYYY-MM-DD');
    const nDaysFromNowFormatted = nDaysFromNow.format('YYYY-MM-DD');
    return {
        nDaysFromNowFormatted,
        nowFormatted
    }
}

export const fixDateRangeCondition = (chartQuery) => {
    if (chartQuery?.timeDimensions) {
        const stationTimeZone = getStoredTimezone()
        const query = JSON.parse(JSON.stringify(chartQuery));
        query.timeDimensions.map((t) => {
            if (typeof (t.dateRange) === 'string') {
                switch (t.dateRange.toLowerCase()) {
                    case 'today':
                        const todayDate = moment().tz(stationTimeZone).format('YYYY-MM-DD');
                        t.dateRange = [todayDate, todayDate];
                        break;
                    case 'yesterday':
                        const yesterdayDate = moment().tz(stationTimeZone).subtract(1, 'days').format('YYYY-MM-DD');
                        t.dateRange = [yesterdayDate, yesterdayDate];
                        break;
                    case 'this week':
                        let start = moment.tz(stationTimeZone);
                        let end = moment.tz(stationTimeZone);
                        t.dateRange = [start.startOf('week').format('YYYY-MM-DD'), end.endOf('week').format('YYYY-MM-DD')]
                        break;
                    case 'this month':
                        const now = moment().tz(stationTimeZone);
                        const startOfMonth = now.clone().startOf('month').format('YYYY-MM-DD');
                        const endOfMonth = now.clone().endOf('month').format('YYYY-MM-DD');
                        t.dateRange = [startOfMonth, endOfMonth];
                        break;
                    case 'this quarter':
                        t.dateRange = [getCurrentQuarterDates().startFormatted, getCurrentQuarterDates().endFormatted];
                        break;
                    case 'this year':
                        t.dateRange = [getCurrentYear().startOfYear, getCurrentYear().endOfYear]
                        break;
                    case 'last 7 days':
                    case 'last 14 days':
                    case 'last 30 days':
                    case 'last 42 days':
                    case 'last 90 days':
                        const nDays = t.dateRange.toLowerCase().split(' ')?.[1];
                        t.dateRange = [getLastNDays(nDays).nDaysAgoFormatted, getLastNDays(nDays).nowFormatted]
                        break;
                    case 'last week':
                        let startL = moment.tz(stationTimeZone).add(-1, 'week');
                        let endL = moment.tz(stationTimeZone).add(-1, 'week');
                        t.dateRange = [startL.startOf('week').format('YYYY-MM-DD'), endL.endOf('week').format('YYYY-MM-DD')];
                        break;
                    case 'last month':
                        t.dateRange = [getLastMonth().startFormattedMonth, getLastMonth().endFormattedMonth]
                        break;
                    case 'last quarter':
                        t.dateRange = [getPreviousQuarter().startFormattedDate, getPreviousQuarter().endFormattedDate]
                        break;
                    case 'last year':
                        t.dateRange = [getPreviousYear().startFormattedDate, getPreviousYear().endFormattedDate]
                        break;
                    case 'next 30 days':
                        const nextDays = t.dateRange.toLowerCase().split(' ')?.[1];
                        t.dateRange = [getNextNDays(nextDays).nowFormatted, getNextNDays(nextDays).nDaysFromNowFormatted]
                        break;
                }
            }
            return t
        })
        return query
    }

    return chartQuery
};

export const revertDateRangeToForNames = (dateRange) => {
    if (!Array.isArray(dateRange)) {
        return dateRange;
    }
    const stationTimeZone = getStoredTimezone();

    // Today 
    const todayDate = moment().tz(stationTimeZone).format('YYYY-MM-DD');
    const todayDateString = [new Date(todayDate).toDateString(), new Date(todayDate).toDateString()].join(',')

    // Yesterday
    const yesterdayDate = moment().tz(stationTimeZone).subtract(1, 'days').format('YYYY-MM-DD');
    const yesterdayDateString = [new Date(yesterdayDate).toDateString(), new Date(yesterdayDate).toDateString()].join(',');

    // this week
    const start = moment().tz(stationTimeZone);
    const end = moment().tz(stationTimeZone);
    const currentWeekstartDate = start.startOf('week').format('YYYY-MM-DD')
    const currentWeekendDate = end.endOf('week').format('YYYY-MM-DD')
    const currentWeekDateString = [new Date(currentWeekstartDate).toDateString(), new Date(currentWeekendDate).toDateString()].join(',');

    // this month
    const now = moment().tz(stationTimeZone);
    const startOfMonth = now.clone().startOf('month').format('YYYY-MM-DD');
    const endOfMonth = now.clone().endOf('month').format('YYYY-MM-DD');
    const thisMonthDateString = [new Date(startOfMonth).toDateString(), new Date(endOfMonth).toDateString()].join(',');

    // this quarter
    const thisQuarterDateString = [new Date(getCurrentQuarterDates().startFormatted).toDateString(), new Date(getCurrentQuarterDates().endFormatted).toDateString()].join(',')

    // this year
    const thisYearDateString = [new Date(getCurrentYear().startOfYear).toDateString(), new Date(getCurrentYear().endOfYear).toDateString()].join(',')

    // last 7 days
    const last7DaysString = [new Date(getLastNDays(7).nDaysAgoFormatted).toDateString(), new Date(getLastNDays(7).nowFormatted).toDateString()].join(',')

    // last 14 days
    const last14DaysString = [new Date(getLastNDays(14).nDaysAgoFormatted).toDateString(), new Date(getLastNDays(14).nowFormatted).toDateString()].join(',')

    // last 30 days
    const last30DaysString = [new Date(getLastNDays(30).nDaysAgoFormatted).toDateString(), new Date(getLastNDays(30).nowFormatted).toDateString()].join(',')

    // last 42 days
    const last42DaysString = [new Date(getLastNDays(42).nDaysAgoFormatted).toDateString(), new Date(getLastNDays(42).nowFormatted).toDateString()].join(',')

    // last 90 days
    const last90DaysString = [new Date(getLastNDays(90).nDaysAgoFormatted).toDateString(), new Date(getLastNDays(90).nowFormatted).toDateString()].join(',')

    // last week
    const startLW = moment().tz(stationTimeZone).add(-1, 'week');
    const endLW = moment().tz(stationTimeZone).add(-1, 'week');
    const lastWeekstartDate = startLW.startOf('week').format('YYYY-MM-DD')
    const lastWeekendDate = endLW.endOf('week').format('YYYY-MM-DD')
    const lastWeekDateString = [new Date(lastWeekstartDate).toDateString(), new Date(lastWeekendDate).toDateString()].join(',');

    // last month
    const lastMonthString = [new Date(getLastMonth().startFormattedMonth).toDateString(), new Date(getLastMonth().endFormattedMonth).toDateString()].join(',');

    // last quarter
    const lastQuarterString = [new Date(getPreviousQuarter().startFormattedDate).toDateString(), new Date(getPreviousQuarter().endFormattedDate).toDateString()].join(',');

    // last year
    const lastYearString = [new Date(getPreviousYear().startFormattedDate).toDateString(), new Date(getPreviousYear().endFormattedDate).toDateString()].join(',');

    // next 30 days
    const next30DaysString = [new Date(getNextNDays(30).nowFormatted).toDateString(), new Date(getNextNDays(30).nDaysFromNowFormatted).toDateString()].join(',')

    const dateRangeString = [new Date(dateRange[0]).toDateString(), new Date(dateRange[1]).toDateString()].join(',');

    if (dateRangeString === todayDateString) {
        return 'Today';
    } else if (dateRangeString === yesterdayDateString) {
        return 'Yesterday';
    } else if (dateRangeString === currentWeekDateString) {
        return 'This week'
    } else if (dateRangeString === thisMonthDateString) {
        return 'This month'
    } else if (dateRangeString === thisQuarterDateString) {
        return 'This quarter'
    } else if (dateRangeString === thisYearDateString) {
        return 'This year'
    } else if (dateRangeString === last7DaysString) {
        return 'Last 7 days'
    } else if (dateRangeString === last14DaysString) {
        return 'Last 14 days'
    } else if (dateRangeString === last30DaysString) {
        return 'Last 30 days'
    } else if (dateRangeString === last42DaysString) {
        return 'Last 42 days'
    } else if (dateRangeString === last90DaysString) {
        return 'Last 90 days'
    } else if (dateRangeString === lastWeekDateString) {
        return 'Last week'
    } else if (dateRangeString === lastMonthString) {
        return 'Last month'
    } else if (dateRangeString === lastQuarterString) {
        return 'Last quarter'
    } else if (dateRangeString === lastYearString) {
        return 'Last year'
    } else if (dateRangeString === next30DaysString) {
        return 'Next 30 Days'
    } else {
        return 'Custom'
    }
}